module.exports = __webpack_public_path__ + "static/w-rega-e957594fe67bef1bdea8f8068e860608.jpg";